module.exports = __webpack_public_path__ + "static/media/eh.68cb52cb.svg";